import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hindi',
  templateUrl: './hindi.component.html',
  styleUrls: ['./hindi.component.scss']
})
export class HindiComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
